import script from "./SimpleCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleCalculator.vue?vue&type=script&setup=true&lang=js"

import "./SimpleCalculator.vue?vue&type=style&index=0&id=5fc803c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc803c4"]])

export default __exports__